export const PARTIAL_REVERSAL_REQUEST = "PARTIAL_REVERSAL_REQUEST"
export const PARTIAL_REVERSAL_SUCCESS = "PARTIAL_REVERSAL_SUCCESS"
export const PARTIAL_REVERSAL_FAIL = "PARTIAL_REVERSAL_FAIL"

export const UPDATE_REVERSAL_REQUEST = "UPDATE_REVERSAL_REQUEST"
export const UPDATE_REVERSAL_SUCCESS = "UPDATE_REVERSAL_SUCCESS"
export const UPDATE_REVERSAL_FAIL = "UPDATE_REVERSAL_FAIL"
export const UPDATE_REVERSAL_RESET = "UPDATE_REVERSAL_RESET"
